/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { BaseButton, Icon } from "@cd2/components"
import { IComponentProp } from "../types/utils"

interface IIconButtonProps {
  icon: IComponentProp<typeof Icon, "icon">
  onClick?(): void
  square?: boolean
  buttonStyle?: "solid" | "outline" | "text"
  disabled?: boolean
  iconSize?: number
  buttonColor?: string
  color?: string
  hoverColor?: string
  prefix?: "solid" | "brands" | "regular" | "light" | "duotone"
}
export function IconButton({
  icon,
  onClick,
  buttonStyle = "text",
  square,
  disabled,
  iconSize = 16,
  buttonColor,
  color,
  hoverColor,
  prefix,
}: IIconButtonProps) {
  return (
    <BaseButton
      buttonStyle={buttonStyle}
      theme={{
        borderRadius: square ? undefined : 20,
        padding: iconSize / 1.666,
        buttonColor: buttonColor ? buttonColor : buttonStyle === "solid" ? "#fff" : "primary",
        color,
        hoverColor,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <div
        css={css`
          height: ${iconSize}px;
          width: ${iconSize}px;
        `}
      >
        <Icon icon={icon} size={iconSize} prefix={prefix} />
      </div>
    </BaseButton>
  )
}
